import { Box, Paper, Typography } from '@mui/material';
import { Fade } from '@mui/material';
import FullPageLoader from '../../system-components/loaders/FullPageLoader';
import LoginButton from './LoginButton';
import React from 'react';
import AnimatedCounter from '../AnimatedCounter';
import { getStats } from '../../../services/stats';

export default function LandingPage() {
    const [loading] = React.useState(false);
    const [countTo, setCountTo] = React.useState(0);
    const boxedLoader = (
        <Box sx={{ height: 'var(--app-height)' }}>
            <FullPageLoader />
        </Box>
    );

    React.useEffect(() => {
        getStats()
            .then((res) => {
                setCountTo(res.total_messages);
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);

    return loading ? (
        boxedLoader
    ) : (
        <Fade in={!loading} timeout={500}>
            <Paper
                elevation={0}
                backgroundColor="primary.main"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'var(--app-height)',
                }}
            >
                {/* Main content */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="h1"
                        mb={3}
                        sx={{
                            // Responsive font sizes for the main heading
                            fontSize: {
                                xs: '2.5rem', // extra-small devices
                                sm: '3rem',   // small devices
                                md: '4rem',   // medium devices
                                lg: '5rem',   // large devices
                            },
                        }}
                    >
                        SuperFastGPT
                    </Typography>
                    <AnimatedCounter
                        countTo={countTo}
                        textBefore=""
                        textAfter="questions answered so far"
                        color="white"
                        variant="caption"
                        sx={{
                            fontSize: '.85rem',
                            mb: 0.5,
                        }}
                    />
                    <LoginButton />
                    <Typography
                        variant="overline"
                        sx={{
                            mt: 4,
                            // Responsive font sizes for the overline text
                            fontSize: {
                                xs: '0.6rem',
                                sm: '0.8rem',
                                md: '.9rem',
                            },
                        }}
                    >
                        A lightning-fast AI assistant that delivers accurate insights
                    </Typography>
                </Box>
                <Box
                    component="footer"
                    sx={{
                        pb: .5,
                        textAlign: 'center',
                        width: '100%',
                    }}
                >
                    <Typography
                        level="body-xs"
                        color='text.secondary'
                        sx={{
                            fontSize: {
                                xs: '0.55rem',
                                sm: '0.775rem',
                                md: '.8rem',
                            },
                        }}
                    >
                        © 2023 Gray Generation{" "}
                        <a href="/privacy" target="_blank" rel="noopener noreferrer">
                            Privacy &amp; Cookies
                        </a>
                    </Typography>
                </Box>
            </Paper>
        </Fade>
    );
}
